import { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useBranch } from "@/context/BranchContext";
import { OrdersProvider } from "@/context/OrdersContext";
import { MenuProvider } from "@/context/MenuContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { NotificationsProvider } from "@/context/NotificationsContext";
import BranchSidebar from "@/components/feature/BranchSidebar";
import BranchHeader from "@/components/feature/BranchHeader";
import GlobalAlerts from "@/components/feature/GlobalAlerts";

export default function BranchLayout() {
  const { isAuthenticated } = useBranch();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <OrdersProvider>
      <MenuProvider>
        <SettingsProvider>
          <NotificationsProvider>
            <div className="min-h-screen w-full bg-background-100 flex overflow-x-hidden">
              <BranchSidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
              <div className="flex-1 min-w-0 flex flex-col min-h-screen">
                <BranchHeader onMenuClick={() => setMobileOpen(true)} />
                <GlobalAlerts />
                <main className="flex-1 min-w-0 p-3 sm:p-4 md:p-6" key={location.pathname}>
                  <Outlet />
                </main>
              </div>
            </div>
          </NotificationsProvider>
        </SettingsProvider>
      </MenuProvider>
    </OrdersProvider>
  );
}